import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";
import Callback from "./Api/callback";
import PaymentHeader from "./Components/Common/paymentHeader.js";
import TermsPage from "./Components/Terms/TermsPage";
import { useSelector } from "react-redux";
import NewReceipt from "./ComponentsV2/NewReceipt";
import Subscription from "./ComponentsV2/Subscription";
import UpdateSuccess from "./ComponentsV2/Subscription/UpdateSuccess";
import Accessibility from "./ComponentsV2/Accessibility/index.jsx";

const Router = (props) => {
  const { userManager } = props;
  const { config } = useSelector((state) => ({
    config: state.config,
  }));
  const [prevHeight, setPrevHeight] = useState(window.innerHeight);

  window.addEventListener("resize", () => {
    if (window.innerHeight !== prevHeight) {
      setPrevHeight(window.innerHeight);
    }
  });

  const loadAnalyticsScript = (config) => {
    const isProduction =
      config?.environment !== "Development" && config?.environment !== "Test";

    if (config && config.shopName && isProduction) {
      const track = document.createElement("script");
      track.type = "text/javascript";
      track.src =
        "https://analytics.entryevent.se/js/script.exclusions.pageview-props.js";
      track.defer = true;
      track.setAttribute("data-domain", "checkout");
      track.setAttribute("event-tenant", `${config.shopName}`);
      track.setAttribute("data-exclude", "/checkout/callback/*");
      document.head.appendChild(track);
    }
  };

  useEffect(() => {
    if (config) {
      loadAnalyticsScript(config);
    }
  }, [config]);

  return (
    <>
      {userManager.error ? (
        <App />
      ) : (
        <BrowserRouter basename="/checkout">
          <Routes>
            <Route
              path="/callback"
              element={<Callback userManager={userManager} />}
            />
            <Route path="/paymentheader/:id" element={<PaymentHeader />} />
            <Route path="/receipt/:id" element={<NewReceipt />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/updateSubscription" element={<Subscription />} />
            <Route path="/updateSuccess" element={<UpdateSuccess />} />
            <Route path="/accessibility" element={<Accessibility />} />

            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
};

export default Router;
